/**
 * @fileoverview gRPC-Web generated client stub for acompanha.subscription_billing.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/subscription_billing/v1/subscription_billing.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.subscription_billing = {};
proto.acompanha.subscription_billing.v1 = require('./subscription_billing_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest,
 *   !proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse>}
 */
const methodDescriptor_SubscriptionBillingService_ListBillingExemptions = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListBillingExemptions',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest,
  proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.listBillingExemptions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListBillingExemptions',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_ListBillingExemptions,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.listBillingExemptions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListBillingExemptions',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_ListBillingExemptions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest,
 *   !proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse>}
 */
const methodDescriptor_SubscriptionBillingService_CreateBillingExemption = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/CreateBillingExemption',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest,
  proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.createBillingExemption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/CreateBillingExemption',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_CreateBillingExemption,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.createBillingExemption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/CreateBillingExemption',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_CreateBillingExemption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest,
 *   !proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse>}
 */
const methodDescriptor_SubscriptionBillingService_RevokeBillingExemption = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/RevokeBillingExemption',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest,
  proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.revokeBillingExemption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/RevokeBillingExemption',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_RevokeBillingExemption,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.revokeBillingExemption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/RevokeBillingExemption',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_RevokeBillingExemption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest,
 *   !proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse>}
 */
const methodDescriptor_SubscriptionBillingService_ListSubscriptionCharges = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListSubscriptionCharges',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest,
  proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.listSubscriptionCharges =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListSubscriptionCharges',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_ListSubscriptionCharges,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.listSubscriptionCharges =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListSubscriptionCharges',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_ListSubscriptionCharges);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest,
 *   !proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse>}
 */
const methodDescriptor_SubscriptionBillingService_GetSubscriptionCharge = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/GetSubscriptionCharge',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest,
  proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.getSubscriptionCharge =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/GetSubscriptionCharge',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_GetSubscriptionCharge,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.getSubscriptionCharge =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/GetSubscriptionCharge',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_GetSubscriptionCharge);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest,
 *   !proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse>}
 */
const methodDescriptor_SubscriptionBillingService_AttachSubscriptionCharge = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/AttachSubscriptionCharge',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest,
  proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.attachSubscriptionCharge =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/AttachSubscriptionCharge',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_AttachSubscriptionCharge,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.attachSubscriptionCharge =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/AttachSubscriptionCharge',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_AttachSubscriptionCharge);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest,
 *   !proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse>}
 */
const methodDescriptor_SubscriptionBillingService_ListSubscriptionPayments = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListSubscriptionPayments',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest,
  proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.listSubscriptionPayments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListSubscriptionPayments',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_ListSubscriptionPayments,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.listSubscriptionPayments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListSubscriptionPayments',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_ListSubscriptionPayments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest,
 *   !proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse>}
 */
const methodDescriptor_SubscriptionBillingService_GetSubscriptionPayment = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/GetSubscriptionPayment',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest,
  proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.getSubscriptionPayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/GetSubscriptionPayment',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_GetSubscriptionPayment,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.getSubscriptionPayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/GetSubscriptionPayment',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_GetSubscriptionPayment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest,
 *   !proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse>}
 */
const methodDescriptor_SubscriptionBillingService_ApproveSubscriptionPayment = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/ApproveSubscriptionPayment',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest,
  proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.approveSubscriptionPayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/ApproveSubscriptionPayment',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_ApproveSubscriptionPayment,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.approveSubscriptionPayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/ApproveSubscriptionPayment',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_ApproveSubscriptionPayment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest,
 *   !proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse>}
 */
const methodDescriptor_SubscriptionBillingService_RejectSubscriptionPayment = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/RejectSubscriptionPayment',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest,
  proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.rejectSubscriptionPayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/RejectSubscriptionPayment',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_RejectSubscriptionPayment,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.rejectSubscriptionPayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/RejectSubscriptionPayment',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_RejectSubscriptionPayment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest,
 *   !proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse>}
 */
const methodDescriptor_SubscriptionBillingService_ListMPSubscriptions = new grpc.web.MethodDescriptor(
  '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListMPSubscriptions',
  grpc.web.MethodType.UNARY,
  proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest,
  proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse,
  /**
   * @param {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServiceClient.prototype.listMPSubscriptions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListMPSubscriptions',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_ListMPSubscriptions,
      callback);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.subscription_billing.v1.SubscriptionBillingServicePromiseClient.prototype.listMPSubscriptions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.subscription_billing.v1.SubscriptionBillingService/ListMPSubscriptions',
      request,
      metadata || {},
      methodDescriptor_SubscriptionBillingService_ListMPSubscriptions);
};


module.exports = proto.acompanha.subscription_billing.v1;

